import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from "react-intl";
import {isMobile, mobileVendor, mobileModel} from 'react-device-detect';
import {POINTS, CREDIT_CARD, SAMSUNG_PAY, STORED_PAYMENT} from './paymentMethodTypes';
import { useSettings } from '../../mall_settings/SettingsProvider';

export const PaymentMethodContext = React.createContext();

export const PaymentMethodProvider = ({ children }) => {
    const {locale} = useIntl();
    const {userPoints, samsungPay, samsungPaySID, americanExpress, discoverCard, masterCard, visa} = useSettings();

    const isSamsungGalaxyClassDevice = isMobile && mobileVendor.toLowerCase().startsWith('samsung') &&
        (navigator.userAgent.match(/SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i) ||
        mobileModel.toLowerCase().startsWith('sm') || mobileModel.toLowerCase().startsWith('gt'));
    const canUseSamsungPay = [(locale.toLocaleLowerCase() === 'en-us'), samsungPay, samsungPaySID,
        window.PaymentRequest, isSamsungGalaxyClassDevice].every(check => check);

    const [selectedMethod, setSelectedMethod] = useState(CREDIT_CARD);
    const [hasPoints, setHasPoints] = useState(userPoints || false);
    const [hasCreditCard, setHasCreditCard] = useState(americanExpress || discoverCard || masterCard || visa);
    const [hasSamsungPay, setHasSamsungPay] = useState(canUseSamsungPay);
    const [methodFailed, setMethodFailed] = useState(false);

    
    const defaultSelected = (hasPoints && POINTS) || (hasSamsungPay && SAMSUNG_PAY) || (hasCreditCard && STORED_PAYMENT) ;

    useEffect(() => {
        
        if (hasPoints) {
            setHasCreditCard(false);
            setHasSamsungPay(false);
        }
        setSelectedMethod(defaultSelected);
    }, [hasPoints, hasCreditCard, hasSamsungPay]);

    useEffect(() => {
        setMethodFailed(false);
    }, [selectedMethod]);

    return (
        <PaymentMethodContext.Provider
            value={{
                selectedMethod,
                setSelectedMethod,
                onMethodError: () => setMethodFailed(true),
                methodFailed,
                hasPoints,
                hasCreditCard,
                hasSamsungPay,
                setHasPoints,
                setHasCreditCard,
                setHasSamsungPay,
                hasMultiplePaymentMethods: [hasPoints, hasCreditCard, hasSamsungPay].filter(hasMethod => hasMethod).length > 1
            }}
        >
            {children}
        </PaymentMethodContext.Provider>
    );
};

PaymentMethodProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export const usePaymentMethods = () => useContext(PaymentMethodContext);
